import './App.css';
import About from './components/about/About';
import Contact from './components/contact/Contact';
import Intro from './components/intro/intro';
import Product from './components/product/Product';
import ProductList from './components/productList/ProductList';

function App() {
  return (
    <div >
       <Intro />
       <About />
       <ProductList />
       <Product />
      <Contact />
    </div>
  );
}

export default App;
